import { ROUTE_QUIZ_CITIES } from '..'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { renderPage } from '../../domain/quiz/quizCities.page'
import { generateFullRoute } from '../../domain/router/route.utils'
import { resetAddress } from '../../store/address/addressSlice'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { resetQuiz } from '../../store/quiz/quizSlice'
import { resetSearchTerms } from '../../store/search/searchSlice'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ store: { dispatch, getState } }) => {
  if (!selectIsFrenchSite(getState())) {
    const path = generateFullRoute(ROUTE_QUIZ_CITIES)
    throw new PermanentRedirectError(path, 'fr.mappy.com')
  }
  return Promise.all([dispatch(resetSearchTerms()), dispatch(resetAddress())])
}

export const onRouteLeave = ({ routeContext }) => {
  const {
    store: { dispatch },
  } = routeContext
  dispatch(resetQuiz())
}

export default handleRouteLoading({ onRouteEnter, onRouteLeave, renderPage })
